import { render, staticRenderFns } from "./rsOrderPayment.vue?vue&type=template&id=4e99a269&scoped=true"
import script from "./rsOrderPayment.vue?vue&type=script&lang=js"
export * from "./rsOrderPayment.vue?vue&type=script&lang=js"
import style0 from "./rsOrderPayment.vue?vue&type=style&index=0&id=4e99a269&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e99a269",
  null
  
)

export default component.exports